import { render, staticRenderFns } from "./goxuanpin.vue?vue&type=template&id=57ebbd3a&scoped=true&"
import script from "./goxuanpin.vue?vue&type=script&lang=js&"
export * from "./goxuanpin.vue?vue&type=script&lang=js&"
import style0 from "./goxuanpin.vue?vue&type=style&index=0&id=57ebbd3a&scoped=lang&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ebbd3a",
  null
  
)

export default component.exports